import React, { useEffect, useState } from 'react';

import { useWindowStore } from '../../stores';

import OnImageDropdown from '../OnImageDropdown/OnImageDropdown';
import BasicDropdown from '../BasicDropdown/BasicDropdown';

import './FinishCollection.scss';

const FinishCollectionNav = ( {
  spaces,
  palettes,
  setActiveSpace,
  setActivePalette,
} ) => {
  const [ spacesToggleActive, setSpacesToggleActive ] = useState( false );
  const [ palettesToggleActive, setPalettesToggleActive ] = useState( false );

  const isMobile = useWindowStore((state) => state.isMobile);

  // Set initial space, i.e. Master Bedroom, Lobby, etc.
  useEffect( () => {
    spaces.forEach( ( space ) => {
      if ( space.isDefault ) {
        setActiveSpace( space.id );
      }
    } );
  }, [ spaces ] );

  const handleSpaceOnClick = ( space ) => {
    setActiveSpace( space.id );
  };

  const handlePaletteOnClick = ( palette ) => {
    setActivePalette( palette.id );
  };

  return ( spaces.length || palettes.length ) && (
    <>
      { isMobile && (
        <div className="finishCollection__mobileControls">
          { spaces.length > 1 && (
            <BasicDropdown
              className="finishCollection__mobileControl"
              label="Space:"
              options={spaces}
              handleOptionOnClick={( space ) => handleSpaceOnClick( space )}
            />
          )}

          { palettes.length > 1 && (
            <BasicDropdown
              className="finishCollection__mobileControl"
              label="Finish:"
              options={palettes}
              handleOptionOnClick={( palette ) => handlePaletteOnClick( palette )}
            />
          )}
        </div>
      )}

      { !isMobile && spaces.length > 1 && (
        <OnImageDropdown
          className="finishCollection__spaces"
          optionsLocation="left"
          closeDropdownOnClick
          options={spaces}
          handleOptionOnClick={( space ) => handleSpaceOnClick( space )}
          useExternalToggle={isMobile}
          externalToggleActive={spacesToggleActive}
        />
      )}

      { !isMobile && palettes.length > 1 && (
        <OnImageDropdown
          className="finishCollection__palettes"
          optionsLocation="altRight"
          closeDropdownOnClick
          options={palettes}
          handleOptionOnClick={( palette ) => handlePaletteOnClick( palette )}
          useExternalToggle={isMobile}
          externalToggleActive={palettesToggleActive}
        />
      )}
    </>
  );
};

export default FinishCollectionNav;
